const ActionTypes = {
    GET_GITHUB_PROFILE: "GET_GITHUB_PROFILE",
    GET_GITHUB_PROFILE_LOADING: "GET_GITHUB_PROFILE_LOADING",
    GET_GITHUB_PROFILE_ERROR: "GET_GITHUB_PROFILE_ERROR",
};

export default ActionTypes;